import './style.scss';
import React, {FC, useMemo} from 'react';
import {Badge} from 'react-bootstrap';
import {parsePrinterType} from '../../../helpers/printer_helper';
import {
  MaterialReactTable,
  MRT_ColumnDef as MRTColumnDef,
} from 'material-react-table';
import {useNavigate} from 'react-router-dom';
import {Typography} from '@mui/material';
import {CsvExportButton} from '../../Common/CsvExportButton';
import moment from 'moment';

interface PrinterListProps {
  isLoading: boolean;
  printers: Printer[];
}

export const PrinterList: FC<PrinterListProps> = ({
  isLoading,
  printers,
}) => {
  const navigate = useNavigate();
  const columns = useMemo<MRTColumnDef<any>[]>(() => [
    {
      header: 'ID',
      accessorKey: 'id',
    },
    {
      header: 'SN',
      accessorKey: 'printer_serial_no',
    },
    {
      header: 'Model',
      accessorKey: 'printer_type',
      accessorFn: (row) => parsePrinterType(row),
    },
    {
      header: 'Dealer',
      accessorKey: 'dealer',
      accessorFn: (row) => row.dealer?.name ?? '',
    },
    {
      header: 'Customer',
      accessorKey: 'customer',
      accessorFn: (row) => row.customer?.name ?? '',
    },
    {
      header: 'Installation',
      accessorKey: 'installation_date',
      accessorFn: (row) =>
        row.installation_date ?
          moment(row.installation_date).format('DD-MM-YYYY') :
          '',
    },
    {
      header: 'Input',
      accessorKey: 'created_at',
      accessorFn: (row) =>
        row.created_at ?
          moment(row.created_at).format('DD-MM-YYYY') :
          '',
    },
    {
      header: 'Status',
      accessorKey: 'guarantee_state',
      Cell: ({cell}) => {
        const state = cell.getValue();
        return (
          <Badge
            pill
            variant={state === 1 ? 'success' : 'danger'}
            className={state === 1 ? 'badge-soft-success' : 'badge-soft-danger'}
          >
            {state === 1 ? 'In guarantee' : 'Not in guarantee'}
          </Badge>
        );
      },
    },
  ], []);

  return (
    <MaterialReactTable
      columns={columns}
      data={printers}
      enableSorting
      enablePagination
      enableGlobalFilter
      state={{isLoading}}
      muiTablePaperProps={{
        elevation: 0,
      }}
      muiTableBodyRowProps={({row}) => ({
        onClick: () => navigate('/printer/' + row.original.id),
        style: {cursor: 'pointer'},
      })}
      renderTopToolbarCustomActions={({table}) => {
        return (
          <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
            <Typography variant="h6">Printers</Typography>
            <CsvExportButton table={table} filename={'printers'}/>
          </div>
        );
      }}
    />
  );
};
